import { render, staticRenderFns } from "./genus-och-plural.vue?vue&type=template&id=336b2769&scoped=true"
import script from "./genus-och-plural.vue?vue&type=script&lang=js"
export * from "./genus-och-plural.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336b2769",
  null
  
)

export default component.exports